import { render, staticRenderFns } from "./subgroup-form.vue?vue&type=template&id=7044a72c&scoped=true&lang=pug&"
import script from "./subgroup-form.vue?vue&type=script&lang=ts&"
export * from "./subgroup-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044a72c",
  null
  
)

export default component.exports